import { Component } from "react";
import ErrorFallback from "./ErrorFallBack";
import { logFrontendError } from "../Services/errorLogger";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  async componentDidCatch(error, info) {
    const errorInfo = { error, info };

    this.setState({ errorInfo });

    try {
      if (typeof this.props.onError === "function") {
        this.props.onError(error, info);
      }
    } catch (callbackError) {
      console.error("Erreur dans onError:", callbackError);
    }

    try {
      await logFrontendError({
        source: "ErrorBoundary",
        error,
        componentStack: info?.componentStack || null,
        extra: {
          boundaryName: this.props.boundaryName || null,
        },
      });
    } catch (loggingError) {
      console.error("Impossible d'envoyer le log d'erreur au backend:", loggingError);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return <ErrorFallback onRetry={this.handleReload} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
